export type ReceiverAction = 'edit' | 'delete';

export type ReceiverDetailsState = {
    accountName: string;
    accountNumber: string;
    action?: ReceiverAction;
};

export const receiverDetailsInitialState: ReceiverDetailsState = {
    accountName: '',
    accountNumber: '',
    action: undefined,
};
